export const PERMISSION_STORE = 'PERMISSION_STORE';
export const PERMISSION_UPDATE = 'PERMISSION_UPDATE';
export const PERMISSION_DESTROY = 'PERMISSION_DESTROY';
